import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    page: { padding: 30, fontSize: 10 },
    // New table styles
    secondTable: {
        border: '1pt solid black',
    },
    secondHeader: {
        flexDirection: 'row',
        backgroundColor: '#f0f0f0',
        fontWeight: 'bold',
        borderBottom: '1pt solid black',
    },
    secondHeaderCell: {
        padding: 6,
        flex: 1,
        borderRight: '1pt solid black',
        textAlign: 'center',
    },
    secondRow: {
        flexDirection: 'row',
    },
    secondCell: {
        padding: 6,
        borderRight: '1pt solid black',
        flex: 1,
        justifyContent: 'center',
    },
    lastCell: {
        borderRight: 'none',
    },
    wid10: {
        flex: 5
    }
});

const VehicleStatement = ({ isFullPage, vehicles, total }) => {
    return (
        isFullPage ? <Document>
            <Page size="A4" style={styles.page}>
                <Text style={{ textAlign: 'center', fontSize:"18px", fontWeight: 600, marginBottom: "5px" }}>{"Vehicle Statement"}</Text>

                {/* Third table: invoice-like structure vehicle wise */}
                <DataSection grandTotal={total} vehicles={vehicles} />
            </Page>
        </Document> : <DataSection grandTotal={total} vehicles={vehicles} />
    );
};

const DataSection = ({ grandTotal, vehicles }) => {
    return <View style={[styles.secondTable, { marginTop: "10px" }]}>
        {/* Header Row */}
        <View style={styles.secondHeader}>
            <Text style={[styles.secondHeaderCell]}>Sl. No.</Text>
            <Text style={[styles.secondHeaderCell, { flex: 4 }]}>Company</Text>
            <Text style={[styles.secondHeaderCell, { flex: 3 }]}>Vehicle</Text>
            <Text style={[styles.secondHeaderCell, { flex: 3 }]}>Installation</Text>
            <Text style={[styles.secondHeaderCell, { flex: 2 }, styles.lastCell]}>Total</Text>
        </View>

        <View>
            {/* Data Rows */}
            {vehicles?.map((row, rowIndex) => (
                <View key={rowIndex} style={[styles.secondRow, rowIndex != vehicles?.length - 1 && { borderBottom: "1px solid black" }]}>
                    <Text style={[styles.secondHeaderCell]}>{rowIndex + 1}</Text>
                    <Text style={[styles.secondHeaderCell, { flex: 4 }]}>{row?.companyname || row?.company || ""}</Text>
                    <Text style={[styles.secondHeaderCell, { flex: 3 }]}>{row?.vehiclenumber || row?.vehicle || ""}</Text>
                    <Text style={[styles.secondHeaderCell, { flex: 3 }]}>{row?.installationdate || ""}</Text>
                    <Text style={[styles.secondHeaderCell, { flex: 2 }, styles.lastCell]}>{row?.totalamount || row?.amount || ""}</Text>
                </View>
            ))}
            <View style={{ flex: 1 }} />
        </View>

        <View style={[styles.secondRow, { borderTop: "1px solid black" }]}>
            <Text style={[styles.secondCell, { flex: 12, padding: 6, textAlign: 'right' }]}>{`Total`}</Text>
            <Text style={[{ flex: 1.98, padding: 6, textAlign: 'center' }]}>{grandTotal}</Text>
        </View>
    </View>
}

export default VehicleStatement;